import { default as Modal } from './AbstractModal'

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = 'has-modal-embed-open'

    constructor(m) {
        super(m)

        // UI
        this.inner = this.$('inner')[0];

        // Data
        this.url = this.getData('url');
    }

    ///////////////
    // Callbacks
    ///////////////
    onInit() {

    }


    onOpen(e) {
        if(this.emptyTimeout) clearTimeout(this.emptyTimeout);

        const { url } = e;
        const provider = this.getVideoProvider(url);
        const id = this. getVideoId(url, provider);

        this.appendDelay = setTimeout(() => {
            this.appendVideo({ provider, id })
        }, 500);

        this.el.classList.add('is-active');
    }

    onClose() {
        clearTimeout(this.appendDelay)

        this.el.classList.remove('is-active')

        this.emptyTimeout = setTimeout(() => {
            this.inner.innerHTML='';
        }, 250);
    }

    appendVideo(obj) {
        const { id, provider } = obj;

        switch (provider) {
            case 'youtube':
                this.inner.innerHTML = `<iframe src='https://www.youtube.com/embed/${id}?&autoplay=1' frameborder='0' fullscreen' allowfullscreen allow='autoplay; fullscreen'></iframe>`;
                break;
            case 'vimeo':
                this.inner.innerHTML = `<iframe src='https://player.vimeo.com/video/${id}?autoplay=1&loop=1&autopause=0' frameborder='0' fullscreen' allowfullscreen></iframe>`;
                break;
            default:
                break;
        }
    }

    getVideoProvider(url) {
        const youtubeRegex =
            /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
        const vimeoRegex = /vimeo\.com\/(\d+|video\/\d+)/;

        if (youtubeRegex.test(url)) {
            return 'youtube';
        } else if (vimeoRegex.test(url)) {
            return 'vimeo';
        }

        return null;
    }

    getVideoId(url, provider) {
        switch (provider) {
            case 'youtube':
                const youtubeRegex =
                    /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*$/i;
                let mYoutube;
                if ((mYoutube = youtubeRegex.exec(url)) !== null) {
                    return mYoutube[1];
                }
            case 'vimeo':
                const vimeoRegex =
                    /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
                let mVimeo;
                if ((mVimeo = vimeoRegex.exec(url)) !== null) {
                    return mVimeo[1];
                }
                break;

            default:
                return null;
        }
    }
}
